/*
 * MONTAGE · Stufen-Offer im Kaufblock
 * ---------------------------------------------------------------------------
 * Zwei Aufgaben, und mehr macht diese Datei nicht:
 *   1. Beim Absenden eines Kaufformulars stehen darin die Zeilen der GEWAEHLTEN
 *      Stufe, und Dawns Einzelvarianten-Feld steht nicht darin.
 *   2. Preisanzeigen, die sonst die Einzelvariante zeigen wuerden, nennen den
 *      Preis der gewaehlten Stufe.
 *
 * Warum Punkt 1 noetig ist, am Live-Shop gemessen (04.09.2026):
 *   `/cart/add` nimmt entweder `id` ODER `items[]`, nie beides. Kommt `id`
 *   mit, faellt die Zugabe still weg; kommt `id` leer mit, antwortet Shopify
 *   "Cannot find variant". Dawn rendert `name="id"` fest in `buy-buttons`.
 *
 * ⚠️ ZWEI KAUFWEGE, siehe EINGRIFFSREGELN.md § 12: Kaufblock UND Sticky-Leiste
 *    haben je ein eigenes <product-form>. Beide muessen die Stufe senden, sonst
 *    kauft die Leiste ein einzelnes Geraet, waehrend oben "Fuer zwei" markiert
 *    ist. Die Warenkorb-Schublade ist ausdruecklich ausgeschlossen: ihr Upsell
 *    ist ein fremdes Produkt und geht uns nichts an.
 *
 * Was hier NICHT passiert (§ 2.2): kein fetch, keine Cart-Route, kein Nachbau
 * eines Formulars, kein Ersetzen von product-form.js. Getauscht wird nur der
 * Inhalt der FormData.
 *
 * ⚠️ FALLBACK OHNE JAVASCRIPT: die im Markup liegenden `items[]`-Felder sind
 *    `disabled`, Dawns `id`-Feld ist aktiv. Bleibt das Skript aus, landet genau
 *    ein Hauptprodukt im Warenkorb. Falsch waere ein leerer Warenkorb, nicht
 *    eine zu kleine Bestellung.
 */
class MTStufen extends HTMLElement {
  connectedCallback() {
    this.eingaben = this.querySelectorAll('.mt-stufen__eingabe');
    // Vorauswahl per Adresse (08.10.2026): Links aus Anzeigenseiten (Advertorial-
    // Angebotsbox) tragen ?menge=3, damit der Korb zur gewaehlten Stufe passt.
    // Ohne Treffer bleibt die Vorauswahl aus Liquid stehen.
    try {
      const menge = new URLSearchParams(location.search).get('menge');
      if (menge) {
        const ziel = [...this.eingaben].find((e) => e.dataset.menge === menge && !e.disabled);
        if (ziel && !ziel.checked) ziel.checked = true;
      }
    } catch (e) {}
    this.formulare = this.formulareSuchen();
    if (!this.formulare.length) return;

    // Jedes Formular bekommt einen eigenen Platz fuer die Zeilen der Stufe.
    // Ein Feld kann per `form`-Attribut nur EINEM Formular gehoeren, deshalb
    // je Formular ein eigener Satz statt eines geteilten.
    this.faecher = this.formulare.map((f) => {
      const fach = document.createElement('div');
      fach.hidden = true;
      fach.dataset.mtFach = '';
      f.appendChild(fach);
      return fach;
    });

    this.eingaben.forEach((e) => e.addEventListener('change', () => this.uebernehmen()));
    // Capture: Dawns eigener submit-Handler baut `new FormData(this.form)`.
    // Unserer muss vorher fertig sein, sonst sendet Dawn den alten Stand.
    this.formulare.forEach((f) => f.addEventListener('submit', () => this.uebernehmen(), true));

    /*
     * Dritte Aufgabe, seit 15.09.2026 (Straw mit Farbwahl): Wechselt die
     * Variante, holt Dawn die Sektion neu, uebernimmt daraus aber nur Preis,
     * Bestand und das `id`-Feld (product-info.js). Die Stufenzeilen trugen
     * weiter die Variante, mit der die Seite geladen wurde, und nach einem
     * Wechsel auf „Schwarz" waere „Blau" im Warenkorb angekommen. Deshalb
     * werden die Zeilen aus genau diesem HTML uebernommen, Muster wie
     * mt-variantentext.js: kein zweiter Abruf, die Varianten-IDs entscheidet
     * Liquid. Seiten ohne Farbwahl (Selfpress) loesen das Ereignis nie aus.
     */
    const produkt = this.closest('product-info');
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.abmelden = subscribe(PUB_SUB_EVENTS.variantChange, (nachricht) => {
        const daten = nachricht && nachricht.data;
        if (!daten || !daten.html) return;
        if (produkt && daten.sectionId !== produkt.sectionId) return;
        this.zeilenUebernehmen(daten.html);
      });
    }

    this.uebernehmen();
  }

  disconnectedCallback() {
    if (this.abmelden) this.abmelden();
  }

  /* Stufenzeilen aus dem neu gerenderten HTML der gewaehlten Variante. */
  zeilenUebernehmen(html) {
    const neu = html.querySelector('.product__info-container mt-stufen');
    if (!neu) return;
    this.querySelectorAll('.mt-stufen__zeilen').forEach((alt) => {
      const gegen = neu.querySelector(`.mt-stufen__zeilen[data-stufe="${alt.dataset.stufe}"]`);
      if (!gegen) return;
      alt.innerHTML = gegen.innerHTML;
      alt.dataset.preis = gegen.dataset.preis;
    });
    /*
     * Seit 16.09.2026 (Squeeze mit Groessenwahl): die Varianten kosten
     * verschieden viel. Ohne diesen Schritt zeigten die Karten nach dem
     * Wechsel auf 1 Liter weiter die 500-ml-Preise, waehrend Knopf und
     * Warenkorb schon 1 Liter trugen. Uebernommen werden der Karteninhalt
     * (Preis, Wert, Kacheln, Ersparnis) und die Waehlbarkeit. Die Auswahl
     * bleibt stehen, weil das Radiofeld nicht Teil der Karte ist.
     */
    this.querySelectorAll('.mt-stufen__eingabe').forEach((eingabe) => {
      const gegen = neu.querySelector(`.mt-stufen__eingabe[value="${eingabe.value}"]`);
      if (!gegen) return;
      eingabe.disabled = gegen.disabled;
      const karte = eingabe.nextElementSibling;
      const gegenKarte = gegen.nextElementSibling;
      if (karte?.matches('.mt-stufen__karte') && gegenKarte?.matches('.mt-stufen__karte')) {
        karte.innerHTML = gegenKarte.innerHTML;
      }
    });
    // Darstellung „kompakt“ (09.10.2026): die Preiszeile unter den Karten
    // haengt ebenfalls an der Variante und kommt mit.
    const summen = this.querySelector('.mt-stufen__summen');
    const gegenSummen = neu.querySelector('.mt-stufen__summen');
    if (summen && gegenSummen) summen.innerHTML = gegenSummen.innerHTML;
    // Ist die gewaehlte Stufe in der neuen Variante nicht lieferbar, springt
    // die Auswahl auf die erste lieferbare. Sonst blieben die Zeilen der
    // alten Variante im Formular stehen.
    const gewaehlt = [...this.eingaben].find((e) => e.checked);
    if (gewaehlt && gewaehlt.disabled) {
      const ersatz = [...this.eingaben].find((e) => !e.disabled);
      if (ersatz) ersatz.checked = true;
    }
    this.uebernehmen();
  }

  /*
   * Nur Formulare, die DIESES Produkt verkaufen.
   *
   * ⚠️ Am 04.09.2026 live aufgetreten: die Seite traegt drei Kaufformulare,
   *    nicht zwei. Neben Kaufblock und Sticky-Leiste steht der Cross-Sell
   *    „Ergaenze dein Produkt", und der verkauft den WECHSELFILTER. Wer dort
   *    kaufte, bekam die Selfpress-Stufe. Ein Formular zaehlt deshalb nur,
   *    wenn sein `id`-Feld auf eine Variante dieses Produkts zeigt.
   *    Das wird EINMAL beim Verbinden geprueft, bevor irgendein Feld
   *    abgeschaltet ist.
   */
  formulareSuchen() {
    const meine = (this.dataset.varianten || '').split(',').filter(Boolean);
    const alle = new Set();
    const eigenes = document.getElementById(this.dataset.form);
    if (eigenes) alle.add(eigenes);

    document.querySelectorAll('product-form form[action*="/cart/add"]').forEach((f) => {
      // Die Schublade laedt vor <main> und wuerde sonst als erstes gefunden.
      if (f.closest('cart-drawer, cart-notification')) return;
      const id = f.querySelector('[name="id"]');
      if (id && meine.includes(id.value)) alle.add(f);
    });
    return [...alle];
  }

  get gewaehlt() {
    const e = [...this.eingaben].find((x) => x.checked && !x.disabled);
    return e ? e.value : null;
  }

  uebernehmen() {
    const stufe = this.gewaehlt;
    const quelle = stufe && this.querySelector(`.mt-stufen__zeilen[data-stufe="${stufe}"]`);
    if (!quelle) return;

    const felder = [...quelle.querySelectorAll('[data-mt-item]')].map((f) => [f.name, f.value]);

    this.faecher.forEach((fach, i) => {
      fach.replaceChildren();
      felder.forEach(([name, wert]) => {
        const el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        el.value = wert;
        fach.appendChild(el);
      });
      /*
       * Dawns Einzelvarianten-Feld stilllegen. Ein deaktiviertes Feld landet
       * nicht in der FormData, das Element bleibt aber im DOM: product-form.js
       * greift in seinem connectedCallback auf `variantIdInput.disabled` zu
       * und wuerde ueber ein entferntes Feld stolpern.
       */
      const id = this.formulare[i].querySelector('[name="id"]');
      if (id) {
        id.disabled = true;
        // Markierung fuer montage-sticky.js: abgeschaltet heisst hier NICHT
        // ausverkauft. Ohne sie stand die Sticky-Leiste dauerhaft auf
        // "Ausverkauft", waehrend der Kaufblock kaufbar war.
        id.dataset.mtStufen = '';
      }
    });

    this.preisZeigen(quelle.dataset.preis);

    // Galerie nachziehen (08.10.2026): die Bildstrecke hoert auf mt:stufe und zeigt das Paketbild der Stufe.
    const eingabe = [...this.eingaben].find((x) => x.checked && !x.disabled);
    if (eingabe && eingabe.dataset.menge) {
      document.dispatchEvent(new CustomEvent('mt:stufe', { detail: { stufe, menge: eingabe.dataset.menge } }));
    }
  }

  /* Preisanzeigen nachziehen. Ohne das steht am Knopf der Preis eines einzelnen
   * Geraets, waehrend die Karte darueber "Fuer zwei" markiert hat. */
  preisZeigen(preis) {
    if (!preis) return;
    const block = this.closest('.shopify-section') || document;

    // Darstellung „kompakt“: der Preis steht gross ueber dem Knopf, der Knopf traegt den Pfeil.
    if (!this.classList.contains('mt-stufen--kompakt')) block.querySelectorAll('.mt-cta').forEach((cta) => {
      // Der Preis steht als CSS-Variable im Knopf, nicht als Textknoten,
      // damit Dawns Markup unangetastet bleibt (siehe mt-produkt-cta.liquid).
      cta.style.setProperty('--mt-cta-preis', `' · ${preis}'`);
      cta.classList.add('mt-cta--preis');
    });

    document.querySelectorAll('.mt-sticky__preis').forEach((el) => {
      el.textContent = preis;
    });
  }
}

if (!customElements.get('mt-stufen')) customElements.define('mt-stufen', MTStufen);
